// src/App.js
import React from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/Auth/PrivateRoute";
import { AuthProvider } from "./contexts/AuthContext";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import SignupPage from "./pages/SignupPage";
import StagePage from "./pages/StagePage";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />
        <Route path="/s/:slug" element={<StagePage />} />
        <Route path="/p/:slug" element={<StagePage previewMode={true} />} />
        <Route path="/" element={<LoginPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
